import FlightsToNearbyAlternatives from './FlightsToNearbyAlternatives';

export default FlightsToNearbyAlternatives;
